document.addEventListener('DOMContentLoaded', () => {
  const panels = document.querySelectorAll('.lc-panel');

  if (!panels.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  panels.forEach((panel) => {
    const summary = panel.querySelector('.lc-panel__summary');
    const body = panel.querySelector('.lc-panel__body');

    if (!summary || !body) return;

    // Set correct initial state
    if (panel.open) {
      body.style.height = 'auto';
      body.style.opacity = '1';
    } else {
      body.style.height = '0px';
      body.style.opacity = '0';
    }

    if (prefersReducedMotion) return;

    summary.addEventListener('click', (event) => {
      event.preventDefault();

      const isOpen = panel.hasAttribute('open');

      if (!isOpen) {
        // OPEN
        panel.setAttribute('open', '');

        const targetHeight = body.scrollHeight;

        body.style.height = '0px';
        body.style.opacity = '0';

        requestAnimationFrame(() => {
          body.style.height = `${targetHeight}px`;
          body.style.opacity = '1';
        });

        const onOpenEnd = (e) => {
          if (e.propertyName !== 'height') return;
          body.style.height = 'auto';
          body.removeEventListener('transitionend', onOpenEnd);
        };

        body.addEventListener('transitionend', onOpenEnd);
      } else {
        // CLOSE
        const startHeight = body.scrollHeight;
        body.style.height = `${startHeight}px`;

        requestAnimationFrame(() => {
          body.style.height = '0px';
          body.style.opacity = '0';
        });

        const onCloseEnd = (e) => {
          if (e.propertyName !== 'height') return;
          panel.removeAttribute('open');
          body.removeEventListener('transitionend', onCloseEnd);
        };

        body.addEventListener('transitionend', onCloseEnd);
      }
    });
  });
});